import React, { Component } from 'react';
import { withProps, compose } from 'recompose';
import DropdownInputBar from 'components/dropdown-input-bar';

class SelectContentDropdown extends React.PureComponent {
  render() {
    return (
      <div className="select-content-dropdown">
        <DropdownInputBar
          iconName="chevron down"
          text={this.props.selectedContent.name}
          check={this.props.check}
          isDefault={
            this.props.selectedContentId === this.props.defaultContentId
          }
        >
          <select
            className="hidden-input"
            onChange={this.props.selectOption}
            value={this.props.selectedContentId}
          >
            {this.props.contentIds.map(id => (
              <option value={id} key={id}>
                {this.props.content[id].name}
              </option>
            ))}
          </select>
        </DropdownInputBar>
      </div>
    );
  }
}

export default SelectContentDropdown;



// WEBPACK FOOTER //
// ./src/components/select-content/select-content-dropdown/index.js